import { AppRoutePath } from 'config/constants';
import { matchPath } from 'react-router-dom';
import type { RightDrawerTabType } from './types';

export const resolveRightDrawerBasePath = ({
  basePath,
  pathname,
}: {
  basePath?: string;
  pathname: string;
}): string => {
  return basePath ?? pathname;
};

export const resolveReporterRootBasePath = (pathname: string): string => {
  const reporterMatch = matchPath({ path: AppRoutePath.REPORTER, end: false }, pathname);
  const reporterBlankMatch = matchPath({ path: AppRoutePath.REPORTER_BLANK, end: false }, pathname);

  return reporterMatch?.pathnameBase ?? reporterBlankMatch?.pathnameBase ?? pathname;
};

export const getRightDrawerBrowsePath = ({
  basePath,
  activeTab,
  search,
}: {
  basePath: string;
  activeTab: RightDrawerTabType;
  search: string;
}): string => {
  return `${basePath}${search}#report-${activeTab}s-browser`;
};

export const getRightDrawerCreatePath = ({
  basePath,
  activeTab,
  priorsSuffix,
}: {
  basePath: string;
  activeTab: RightDrawerTabType;
  priorsSuffix: string;
}): string => {
  return `${basePath}/${activeTab}/new${priorsSuffix}`;
};

export const getRightDrawerEditPath = ({
  basePath,
  activeTab,
  itemId,
  priorsSuffix,
}: {
  basePath: string;
  activeTab: RightDrawerTabType;
  itemId: string;
  priorsSuffix: string;
}): string => {
  return `${basePath}/${activeTab}/${itemId}/edit${priorsSuffix}`;
};

export const getRightDrawerClonePath = ({
  basePath,
  activeTab,
  itemId,
}: {
  basePath: string;
  activeTab: RightDrawerTabType;
  itemId: string;
}): string => {
  return `${basePath}/${activeTab}/${itemId}/clone`;
};
